import * as ROUTES from './routes';

export { ROUTES };
